export default __webpack_public_path__ + "static/media/mclogo.fbc30ff0.png";